export default __webpack_public_path__ + "static/media/MaskGroup210.52ce6960.png";